import type { TemplateFunction, TemplateResult } from 'Components/types';
import { dialogClosed } from 'Core/actions/dialog';
import { totalHitsSelector } from 'Core/selectors/search';
import { useDispatch, useSelector } from 'Core/store';
import { cloneSafe } from 'Utils/components';

interface Props {
  template: TemplateFunction<ShowResultsButtonTemplateParams>;
}

export interface ShowResultsButtonTemplateParams {
  totalHits: number;
}

export default function ShowResultsButton({ template }: Props): TemplateResult {
  const dispatch = useDispatch();
  const totalHits = useSelector(totalHitsSelector);

  const onClick = () => dispatch(dialogClosed());

  const component = template.call({ totalHits });
  return cloneSafe(component, null, { onClick });
}
